import { Directive, ElementRef, Input, OnChanges } from '@angular/core';

/** Sets native indeterminate only — checked state comes from [checked] + (change). */
@Directive({
  selector: 'input[type=checkbox][appIndeterminate]',
})
export class IndeterminateCheckboxDirective implements OnChanges {
  @Input('appIndeterminate') indeterminate = false;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  ngOnChanges(): void {
    this.el.nativeElement.indeterminate = !!this.indeterminate;
  }
}
